<template>
  <div class="header-details gap-6 grid grid-cols-2 grid-rows-1 rounded-lg">
    <job-opportunity-details
      :job="job"
      data-cy="job-opportunity-details"
      @save-success="refreshJob"
    />
    <job-commissions-details :job="job" @save-success="refreshJob" />
    <job-times-details :job="job" />
    <job-details class="d-flex flex-column" :job="job" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import JobCommissionsDetails from "@/Job/Commissions/JobCommissionsDetails.vue";
import JobTimesDetails from "@/Job/Header/JobTimesDetails.vue";
import JobOpportunityDetails from "@/Job/Opportunity/JobOpportunityDetails.vue";
import JobDetails from "./JobDetails.vue";

export default {
  components: {
    JobCommissionsDetails,
    JobOpportunityDetails,
    JobTimesDetails,
    JobDetails
  },
  computed: {
    ...mapState(["job"])
  },
  methods: {
    ...mapActions(["fetchJob"]),
    refreshJob() {
      this.fetchJob({ jobId: this.job.id });
    }
  }
};
</script>

<style lang="scss" scoped>
.header-details {
  font-size: 0.75rem;
  padding: 1rem;
  background-color: var(--light-gray);
}
.item-section {
  padding: 0 10px;
}
</style>
